import { render, staticRenderFns } from "./UpdateUnitList.vue?vue&type=template&id=2c439892&scoped=true&"
import script from "./UpdateUnitList.vue?vue&type=script&lang=js&"
export * from "./UpdateUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c439892",
  null
  
)

export default component.exports